module.exports = __webpack_public_path__ + "img/activities-2.7ddc7bfc.jpg";